import './DataExplorer.scss'
import React, { useRef, useEffect } from 'react'
import { useDataExplorer } from './useDataExplorer'
import { MediaModal } from './MediaModal'
import { TabNavigation } from './components/TabNavigation'
import { GalleryTab } from './components/GalleryTab'
import { MapTab } from './components/MapTab'
import { ObservationsTab } from './components/ObservationsTab'
import { TABS, TAB_LABELS } from './constants'

export function DataExplorer({ isOpen, onClose, observations }) {
  const galleryGridRef = useRef(null)
  
  const {
    filterOptions,
    selectedFilters,
    displayedImages,
    loading,
    hasMore,
    selectedItem,
    activeTab,
    viewMode,
    currentSite,
    currentSiteImages,
    currentImage,
    currentSiteIndex,
    siteNames,
    setSelectedItem,
    handleFilterToggle,
    handleScroll,
    clearAllFilters,
    setActiveTab,
    setViewMode,
    navigateToNextSite,
    navigateToPrevSite,
    navigateToNextImage,
    navigateToPrevImage,
    selectSite,
  } = useDataExplorer(isOpen, onClose)

  // Scroll gallery to top when filters change
  useEffect(() => {
    if (activeTab === TABS.GALLERY && galleryGridRef.current) {
      galleryGridRef.current.scrollToTop()
    }
  }, [selectedFilters, activeTab])

  if (!isOpen) return null

  const tabs = [
    { id: TABS.MAP, label: TAB_LABELS[TABS.MAP] },
    { id: TABS.GALLERY, label: TAB_LABELS[TABS.GALLERY] },
    { id: TABS.OBSERVATIONS, label: TAB_LABELS[TABS.OBSERVATIONS] },
  ]

  return (
    <div className="data-explorer">
      <div className="data-explorer__backdrop" onClick={onClose} />
      
      <div className="data-explorer__modal">
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <div className="data-explorer__content">
          {loading ? (
            <div className="data-explorer__loading">
              <p>Loading data...</p>
            </div>
          ) : (
            <>
              {activeTab === TABS.GALLERY && (
                <GalleryTab
                  ref={galleryGridRef}
                  filterOptions={filterOptions}
                  selectedFilters={selectedFilters}
                  displayedImages={displayedImages}
                  viewMode={viewMode}
                  hasMore={hasMore}
                  loading={loading}
                  onFilterToggle={handleFilterToggle}
                  onClearAllFilters={clearAllFilters}
                  onViewModeChange={setViewMode}
                  onItemClick={setSelectedItem}
                  onScroll={handleScroll}
                />
              )}

              {activeTab === TABS.MAP && (
                <MapTab
                  currentSite={currentSite}
                  currentSiteImages={currentSiteImages}
                  currentImage={currentImage}
                  currentSiteIndex={currentSiteIndex}
                  siteNames={siteNames}
                  onPrevSite={navigateToPrevSite}
                  onNextSite={navigateToNextSite}
                  onPrevImage={navigateToPrevImage}
                  onNextImage={navigateToNextImage}
                  onImageClick={setSelectedItem}
                  onSiteSelect={selectSite}
                />
              )}

              {activeTab === TABS.OBSERVATIONS && (
                <ObservationsTab observations={observations} />
              )}
            </>
          )}
        </div>
      </div>

      {selectedItem && (
        <MediaModal
          item={selectedItem}
          allItems={activeTab === TABS.MAP ? currentSiteImages : displayedImages}
          onClose={() => setSelectedItem(null)}
          onNavigate={setSelectedItem}
        />
      )}
    </div>
  )
}
